import { TKeyValuePair } from 'library/ts/types/TKeyValuePair';
import { Comparator } from 'library/ts/utilities/compare/Comparator';
import { TComparatorSettings } from 'library/ts/utilities/compare/TComparatorSettings';

/**
 * Compares two objects and generates a "report" object.
 * Could be expanded in the future to detect and compare other types.
 * @param {TKeyValuePair} leftSubject
 * @param {TKeyValuePair} rightSubject
 * @param {TComparatorSettings} settings
 * @returns {TKeyValuePair}
 */
export const compare = ( leftSubject: TKeyValuePair, rightSubject: TKeyValuePair, settings: TComparatorSettings = {} ): TKeyValuePair => {
	// create Comparator and compare input objects
	let comparator = new Comparator( settings );
	const results = comparator.compareObjects( leftSubject, rightSubject );

	// mark instance for garbage collection
	comparator = undefined;

	return results;
};